import { render, staticRenderFns } from "./BtnCancelarAcao.vue?vue&type=template&id=c7afe85e"
import script from "./BtnCancelarAcao.vue?vue&type=script&lang=js"
export * from "./BtnCancelarAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports